import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import './polyfill';
import React, {StrictMode} from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import {icons} from './assets/icons';

import {Provider} from 'react-redux';
import store from './store';
import {ThemeProvider} from './ThemeContext';

React.icons = icons;

ReactDOM.render(<Provider store={store}>
  <ThemeProvider>
    <StrictMode>
      <App/>
    </StrictMode>
  </ThemeProvider>
</Provider>, document.getElementById('root'));

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js');
  });

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    window.location.reload();
  });
}
